if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        if(this.hasAttribute("disable")) return;

        this.form = this.querySelector('form[id^="product-form-"]');
        this.variantIdInput.disabled = false;
        this.form && this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if(this.submitButton){
          this.submitButtonText = this.submitButton.querySelector('span');

          if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.waitlist = document.querySelector("waitlist-element");
        this.initJoinButton();
      }

      initJoinButton(){
        if(!this.waitlist) return;
        this.joinButton = this.querySelector('[data-join-waitlist-button]');
        if(this.joinButton){
          this.joinButton.addEventListener('click', this.joinButtonClick.bind(this));
        }
      }

      joinButtonClick(){
        const formData = new FormData(this.form);
        const productData = document.querySelector("variant-selects").getProductData();
        const selectedVariant = productData.variants.find(e => e.id == formData.get('id'));
        publish("join-waitlist", { title: productData.title, variant: selectedVariant });
      }

      showWaitlistPopup(){
        this.waitlistForm.show();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const formData = new FormData(this.form);
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const combinationArr = [];

        document.querySelectorAll('combination-product').forEach((item) => {
          if (!item.selectedVariant || !item.selectedVariant.id) {
            return;
          }
          combinationArr.push({
            id: item.selectedVariant.id,
            quantity: Number(formData.get('quantity') || '1')
          });
        });

        console.log("combinationArr", combinationArr);

        if (document.querySelectorAll('combination-product').length > 0 && combinationArr.length === 0) {
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
          return;
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        const resCallback = (response) => {
          console.log(response);
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButtonText.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            }).then(() => {
              CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
            });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  CartPerformance.measure("add:paint-updated-sections", () => {
                    this.cart.renderContents(response);
                  });
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            CartPerformance.measure("add:paint-updated-sections", () => {
              if (this.cart && response.sections) {
                this.cart.renderContents(response);
              } else if (this.cart) {
                this.cart.open();
              }
            });
          }
        }

        if(combinationArr.length > 0){
          const requestBody = {
            items: combinationArr,
            sections_url: window.location.pathname
          };
          
          if (this.cart) {
            requestBody.sections = this.cart.getSectionsToRender().map((section) => section.section);
          }
          
          console.log("请求体:", requestBody);
          console.log("请求URL:", `${routes.cart_add_url}.js`);
          
          fetch(`${routes.cart_add_url}.js`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(requestBody),
          }).then((response) => {
            if (!response.ok) {
              return response.text().then(text => {
                try {
                  return JSON.parse(text);
                } catch (e) {
                  throw new Error(text || '网络错误');
                }
              });
            }
            return response.json();
          }).then(resCallback).catch((e) => {
            console.error("add to cart error: ", e);
            this.error = true;
            this.handleErrorMessage(e.message || '网络错误，请重试');
          }).finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            CartPerformance.measureFromEvent("add:user-action", evt);
          });
          return;
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config).then((response) => response.json()).then(resCallback).catch((e) => {
          console.error(e);
        }).finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
          CartPerformance.measureFromEvent("add:user-action", evt);
        });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text, html) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if(html) this.submitButton.innerHTML = html;
          else if (text) this.submitButtonText.textContent = text;
          this.initJoinButton();
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form?.querySelector('[name=id]') || {};
      }
    }
  );
}

if(!customElements.get('waitlist-element')){
  customElements.define('waitlist-element', class WaitlistElement extends HTMLElement {
    constructor() {
      super();

      this.title = "";
      this.options = "";

      this.dialog = this.querySelector('.dialog');
      this.dialog?.addEventListener('click', this.hide.bind(this));

      this.klaviyo = this.querySelector('[class^="klaviyo-form-"]');
      console.log(this.klaviyo);
      if(!this.klaviyo) return;
      const observer = new MutationObserver(this.klaviyoLoaded.bind(this));
      observer.observe(this, { childList: true, subtree: true });

      this.info = "";
      this.joinWaitlistUnsubscriber = subscribe("join-waitlist", this.joinWaitlist.bind(this));
    }

    klaviyoLoaded(){
      console.log("klaviyo loaded");
      this.productTitleInput = this.querySelector('[id^="product_title_"]');
      this.productOptionsInput = this.querySelector('[id^="product_options_"]');

      this.updateInfo();
      if(this.productTitleInput) {
        const productTitleField = this.productTitleInput.closest('[data-testid="form-row"]');
        if(productTitleField) productTitleField.style.display = 'none';
      }
      if(this.productOptionsInput) {
        const productOptionsField = this.productOptionsInput.closest('[data-testid="form-row"]');
        if(productOptionsField) productOptionsField.style.display = 'none';
      }
    }

    updateInfo(){
      if(this.productTitleInput) {
        this.productTitleInput.value = this.title;
        this.productTitleInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
      if(this.productOptionsInput) {
        this.productOptionsInput.value = this.options;
        this.productOptionsInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }

    handleSubmit(e){
      e.preventDefault();
      const formData = new FormData(this.form);
      const data = {
        "form_type": formData.get('form_type'),
        "contact[Email]": formData.get('contact[Email]'),
        "contact[Comment]": formData.get('contact[Comment]'),
      }
      formData.entries().forEach(([key, value]) => {
        data[key] = value;
      });
      
      fetch('/contact#ContactForm', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
        body: JSON.stringify(data),
      }).then((res) => res.json()).then((response) => {
        console.log(response);
      });
    }

    joinWaitlist({ title, variant }){
      console.log(title, variant);
      this.title = title;
      this.options = variant.title;
      this.updateInfo();
      this.show();
    }

    show(){
      this.setAttribute('show', '');
    }

    hide(){
      this.removeAttribute('show');
    }
  });
}